const isHomePath = path => path.includes('____l____e____x____e____r____')

export const homePageState = {
    defaultState: (path = window.location.pathname) => ({
        homePageEnabled: isHomePath(path),
        initialHomeScreenPassed: isHomePath(path),
    }),
    actions: {
        showHomePage: (homePageIntent = null, state) => ({
            ...state,
            homePageEnabled: true,
            homePageIntent,
            initialHomeScreenPassed: true,
        }),
        hideHomePage: (_, state) => ({...state, homePageEnabled: false, homePageIntent: null}),
        markInitialHomeScreenPassed: (_, state) => ({...state, initialHomeScreenPassed: true}),
    },
}
